import { parseTime, parseTimerOptions } from "../support/helpers";
import { INVISIBLE_START_EVENT } from "../support/tokens";
import InvisibilityTiming from "../invisibility";

import {
  isFunction,
  isPlainObject,
  objectWithAccessors,
  withProperties
} from "../../utils";

export default function createTimer(init) {
  const {
    tick: __tick__,
    updater: __updater__
  } = isPlainObject(init) ? init : {};

  return function __createTimer__(options) {
    if (!isFunction(__tick__)) return false;

    let cb = null;
    let current = 0;
    let timerID = 0;
    let stopped = false;
    let ticking = false;

    let { callback, duration, autostart } = parseTimerOptions(options);

    duration = duration || 60; // duration in seconds

    function _watchVisibility() {
      function _timerVisibilityWatchCallback(data) {
        if (ticking !== true) {
          const { seconds = 0 } = isPlainObject(data) ? data : {};
          const approxSeconds = Math.floor(seconds);
          current += approxSeconds;
          timerID = setTimeout(_tickTimer, 1000 * (seconds - approxSeconds));
          ticking = true;
        }
      }

      function _tickTimer() {
        if (!stopped) {
          _updateWatchers();

          if (++current && __tick__({ current, duration }) === true) {
            timerID = setTimeout(_tickTimer, 1000);
          } else (stopTimer(), stopped = true, callback());
        }
      }

      function _updateWatchers() {
        if (isFunction(__updater__)) {
          return (_updateWatchers = function () {
            return __updater__({ current, duration });
          })();
        }
      }

      return (_watchVisibility = function _watchVisibilityFinal() {
        _timerVisibilityWatchCallback();
        cb = InvisibilityTiming.registerCallback(_timerVisibilityWatchCallback);
        addEventListener(INVISIBLE_START_EVENT, _clearTimer);
      }).call(this);
    }

    function _unwatchVisibility() {
      (cb && InvisibilityTiming.unregisterCallback(cb), cb = null);
      removeEventListener(INVISIBLE_START_EVENT, _clearTimer);
    }

    function _clearTimer() {
      timerID && clearTimeout(timerID);
      timerID = 0;
      ticking = false;
    }

    function extendTimer(extraDuration) {
      if (!stopped) {
        extraDuration = parseTime(Math.ceil(extraDuration));
        return (duration += extraDuration, extraDuration);
      }
    }

    function stopTimer() {
      if (!stopped) {
        ticking !== false && (_unwatchVisibility(), _clearTimer());
        return true;
      }
    }

    function startTimer() {
      if (!(stopped || ticking === true)) {
        _watchVisibility();
        return true;
      }
    }

    const $timerObject = withProperties(Object.create(null), {
      pause: (...args) => stopTimer(...args) || false,
      play: (...args) => startTimer(...args) || false,
      stop: (...args) => stopTimer(...args) ? (stopped = true) : false,
      extend: (...args) => {
        const extended = extendTimer(...args);
        return extended == undefined ? null : extended;
      },
    });

    objectWithAccessors.call($timerObject, {
      ticking: () => !!timerID
    });

    autostart && startTimer();
    
    return $timerObject;
  }
}
